export default "__VITE_ASSET__BiS$fcea__"